import React from 'react';
import { Line } from 'react-chartjs-2';
import { DollarSign } from 'lucide-react';

export function RevenueChart() {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Monthly Revenue',
        data: [38500, 42000, 40800, 43200, 45200, 48000],
        borderColor: 'hsl(var(--primary))',
        backgroundColor: (context: any) => {
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, context.chart.height);
          gradient.addColorStop(0, 'hsla(var(--primary), 0.2)');
          gradient.addColorStop(1, 'hsla(var(--primary), 0)');
          return gradient;
        },
        tension: 0.4,
        fill: true
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context: any) => `₹${context.raw.toLocaleString()}`
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value: any) => `₹${value.toLocaleString()}`
        }
      }
    }
  };

  return (
    <div className="theme-card p-6">
      <div className="flex items-center gap-3 mb-6">
        <DollarSign className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Revenue Overview</h2>
      </div>
      <div className="h-[300px]">
        <Line data={data} options={options} />
      </div>
    </div>
  );
}